import React from 'react';
import AboutHero from '../components/AboutHero';
import AboutProfileBlock from '../components/AboutProfileBlock';
import CoreExpertiseGrid from '../components/CoreExpertiseGrid';
import WhyChooseUss from '../components/WhyChooseUss';
import PracticalApproach from '../components/PracticalApproach';
import StudentSuccessSectors from '../components/StudentSuccessSectors';
import FooterCTA from '../components/FooterCTA';
const About = () => {
  return (
    <div className="gfi-about-page-wrapper">
      
      {/* 1. TOP HEADER HERO BANNER & KEY METRICS STATS */}
      <AboutHero />
       <AboutProfileBlock />
        <CoreExpertiseGrid />
          <WhyChooseUss />
            <PracticalApproach /> 
             <StudentSuccessSectors /> 
                <FooterCTA/>
      {/* [Bhai, agla component jo bhi banana hoga, wo iske niche add hota chala jayega] */}

    </div>
  );
};

export default About;